import Drawer from "@mui/material/Drawer";
import {
  AppBar,
  Avatar,
  Box,
  CircularProgress,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { List } from "reactstrap";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SchoolIcon from "@mui/icons-material/School";
import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_USER_HEADER } from "apollo-client/queries";
const UserMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const { data: userData, loading: isLoadingUserData } =
    useQuery(GET_USER_HEADER);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    localStorage.removeItem("token");
    window.location.reload();
  };

  return (
    <div>
      {isLoadingUserData && <CircularProgress />}
      {!isLoadingUserData && (
        <IconButton onClick={handleClick} sx={{ p: 0 }}>
          <Stack direction="column">
            <Avatar alt="Remy Sharp" src={userData?.user?.profilePicture} />
            <Typography color={"white"}>{userData?.user?.username}</Typography>
          </Stack>
        </IconButton>
      )}

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleClose && logout}>Logout</MenuItem>
      </Menu>
    </div>
  );
};

function TopBar({ setIsDrawerOpen, isDrawerOpen }) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        // color={"primary"}
        style={{ background: "#212529" }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={() => setIsDrawerOpen(!isDrawerOpen)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Blag - Console
          </Typography>
          <UserMenu />
        </Toolbar>
      </AppBar>
      <div style={{ height: "64px" }} />
    </Box>
  );
}

const SideBar = ({ isDrawerOpen, setIsDrawerOpen }) => {
  const navigate = useNavigate();

  return (
    <Drawer
      open={isDrawerOpen}
      onClose={() => setIsDrawerOpen(false)}
      anchor={"left"}
      variant={"temporary"}
    >
      <Box
        sx={{ width: "auto" }}
        role="presentation"
        onClick={() => setIsDrawerOpen(!isDrawerOpen)}
        // onKeyDown={toggleDrawer(anchor, false)}
      >
        <Toolbar />
        <Divider />
        <List>
          <ListItem key={"abuse_reports"} disablePadding>
            <ListItemButton onClick={() => navigate("/abuse-reports")}>
              <ListItemIcon>
                <SentimentVeryDissatisfiedIcon />
              </ListItemIcon>
              <ListItemText primary={"Meldungen"} />
            </ListItemButton>
          </ListItem>
          <ListItem key={"new_course_suggestions"} disablePadding>
            <ListItemButton onClick={() => navigate("/new-course-suggestions")}>
              <ListItemIcon>
                <SchoolIcon />
              </ListItemIcon>
              <ListItemText primary={"Kursvorschläge"} />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );
};
export const MainLayout = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <TopBar setIsDrawerOpen={setIsDrawerOpen} isDrawerOpen={isDrawerOpen} />
      <SideBar isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} />
      {children}
    </>
  );
};
